/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'

import { DatePicker as MaterialDate } from 'material-ui'
import { grey500, grey800, red500 } from 'material-ui/styles/colors'
import ClearIcon from 'material-ui/svg-icons/navigation/cancel'
import IconButton from 'material-ui/IconButton'

import { isDisabled } from './fields'
import * as constants from './constants'

class DatePicker extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)
  }

  handleClear (e) {
    if (!isDisabled(this.props.meta) && !this.props.disabled) {
      this.props.onChange({target: {name: this.props.name}}, null)
    }
  }

  setField (field) {
    if (this.props.getField) {
      this.props.getField(field)
    }
  }

  handleChange (event, value) {
    this.props.onChange({target: {name: this.props.name}}, value)
  }

  setFloatingLabelText (floatingLabelText, meta) {
    if (floatingLabelText && meta && meta.mandatory) {
      return [floatingLabelText, <span key={0} style={{color: red500, fontSize:20, verticalAlign:'sub'}}> *</span>]
    }

    return floatingLabelText
  }

  render () {
    const { floatingLabelText, meta, value, onChange, intl, getField, divStyle, ...rest } = this.props
    const componentProps = {
      disabled: isDisabled(meta),
      floatingLabelText: this.setFloatingLabelText(floatingLabelText, meta),
      ...rest
    }
    const disabled = componentProps.disabled

    const DateTimeFormat = function (...args) {
      let formatter = Intl.DateTimeFormat(...args)

      let newFormatter = {
        format: function (date) {
          let newDate = new Date(date.getTime())
          newDate.setHours(1)
          return formatter.format(newDate)
        }
      }
      return newFormatter
    }

    return (
      <div
        style={
          divStyle
            ? divStyle
            : {
                height: componentProps.multiLine ? 'auto' : 72,
                width: this.props.fullWidth ? '100%' : undefined,
                position: 'relative'
              }
        }
      >
        <MaterialDate
          floatingLabelFixed
          inputStyle={disabled ? {color: grey800} : null}
          className='datepicker'
          locale={this.props.intl.locale}
          DateTimeFormat={DateTimeFormat}
          onChange={this.handleChange}
          fullWidth={true}
          errorStyle={{fontSize:10}}
          {
          ...componentProps
          }
          value={value ? new Date(value) : undefined}
          ref={this.setField}
          cancelLabel={this.props.intl.formatMessage(constants.messages.CANCEL_LABEL)}
          okLabel={this.props.intl.formatMessage(constants.messages.OK_LABEL)}
        />
        {
          value && !isDisabled(this.props.meta) && !this.props.disabled
          ? <IconButton
            style={{position: 'absolute', right: 0, bottom: 0}}
            iconStyle={{width: 20, height: 20}}
            onClick={this.handleClear}
          >
            <ClearIcon color={ grey500 }/>
          </IconButton>
          : undefined
        }
        {
          meta &&
          meta.mandatory &&
          !value &&
          !this.props.errorText
            ? <p className={'error-message'} style={{margin: 0}}>
              {this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)}
            </p>
            : undefined
        }
      </div>
    )
  }
}

export default injectIntl(DatePicker)



// WEBPACK FOOTER //
// ./src/generic/form/DatePicker.js